// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ikAcO","colBig":"styles_colBig__3OGxB","colSmall":"styles_colSmall__dddi8"};